import React from 'react';
const DTNoeFooter = () => {
    return (
        <footer class="bg-white py-4 ">
        <div class="container my-auto ">
            <div class="copyright text-center my-auto ">
                <img src={require("../../common/images/diva-icon.png")} class="logo-img " alt="Logo "/> <span><i>Powered by Amploglobal</i></span>
            </div>
        </div>
    </footer>
    )
}
export default DTNoeFooter;